/* eslint-disable object-curly-newline */
import getDefaultState from './get-default-state';

export default {
  setCartLockVersion(state, lockVersion) {
    state.shoppingCart.lockVersion = lockVersion;
  },

  setShoppingCart(state, shoppingCart) {
    state.shoppingCart = shoppingCart;
  },

  addProduct(state, product) {
    if (!state.shoppingCart.products.find(p => p.id === product.id)) {
      state.shoppingCart.products.push(product);
    }
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },

};
